import { type BibleViewOptions } from '../dm/Bible.js';

const OPTION_KEY_MAP: Record<string, keyof BibleViewOptions> = {
  r: 'redLetters',
  f: 'footnotes',
  h: 'headings',
  v: 'verseNums',
  c: 'crossRef',
};

const DEFAULT_OPTIONS: BibleViewOptions = {
  redLetters: false,
  footnotes: true,
  headings: true,
  verseNums: true,
  crossRef: true,
};

export const parseBibleViewOptions = (rawString?: string): BibleViewOptions => {
  const options: BibleViewOptions = { ...DEFAULT_OPTIONS };

  if (!rawString) return options;

  for (const pair of rawString.split(';')) {
    if (!pair) continue;

    const [shortKey, value] = pair.split('=');
    const key = OPTION_KEY_MAP[shortKey] as keyof BibleViewOptions | undefined;
    if (key) {
      options[key] = value === 't';
    }
  }

  return options;
};

export const serializeBibleViewOptions = (options: BibleViewOptions): string => {
  return Object.entries(OPTION_KEY_MAP)
    .map(([shortKey, key]) => `${shortKey}=${options[key] ? 't' : 'f'}`)
    .join(';');
};
